import { render, staticRenderFns } from "./MpCrosswordV2.vue?vue&type=template&id=6bcdc8af&scoped=true&"
import script from "./MpCrosswordV2.vue?vue&type=script&lang=js&"
export * from "./MpCrosswordV2.vue?vue&type=script&lang=js&"
import style0 from "./MpCrosswordV2.vue?vue&type=style&index=0&id=6bcdc8af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdc8af",
  null
  
)

export default component.exports